import * as Constants from '../constants/activity';

export const getUserActivityTypes = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_ACTIVITY_TYPES_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/activity-types/`,
      params,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_ACTIVITY_TYPES_FAILED, payload: error });
        reject(error);
      });
  });

export const createUserActivityType = ($http, ENV, activityTypeInfo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_USER_ACTIVITY_TYPE_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/activity-types/`,
      data: activityTypeInfo,
    })
      .then((res) => {
        dispatch({
          type: Constants.CREATE_USER_ACTIVITY_TYPE_SUCCESS,
          payload: res.data['activity-types'],
        });
        resolve(res.data['activity-types']);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_USER_ACTIVITY_TYPE_FAILED, payload: error });
        reject(error);
      });
  });

export const getUserActivityType = ($http, ENV, activityTypeId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_ACTIVITY_TYPE_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/activity-types/${activityTypeId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_USER_ACTIVITY_TYPE_SUCCESS,
          payload: res.data['activity-types'],
        });
        resolve(res.data['activity-types']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_ACTIVITY_TYPE_FAILED, payload: error });
        reject(error);
      });
  });

export const updateUserActivityType = ($http, ENV, activityTypeId, activityTypeInfo) => (
  dispatch,
) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_USER_ACTIVITY_TYPE_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/activity-types/${activityTypeId}/`,
      data: activityTypeInfo,
    })
      .then((res) => {
        dispatch({
          type: Constants.UPDATE_USER_ACTIVITY_TYPE_SUCCESS,
          payload: res.data['activity-types'],
        });
        resolve(res.data['activity-types']);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_USER_ACTIVITY_TYPE_FAILED, payload: error });
        reject(error);
      });
  });

export const getUserActivityTypesByUrl = ($http, url) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_USER_ACTIVITY_TYPES_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_USER_ACTIVITY_TYPES_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const createUserActivity = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_USER_ACTIVITY_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/user-activities/`,
      data,
    })
      .then((res) => {
        dispatch({
          type: Constants.CREATE_USER_ACTIVITY_SUCCESS,
          payload: res.data['user-activities'],
        });
        resolve(res.data['user-activities']);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_USER_ACTIVITY_FAILED, payload: error });
        reject(error);
      });
  });

export const reissueExpiredPoints = ($http, ENV, id, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.REISSUE_EXPIRED_POINTS_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/user-activities/${id}/`,
      data,
    })
      .then((res) => {
        dispatch({
          type: Constants.REISSUE_EXPIRED_POINTS_SUCCESS,
          payload: res.data['user-activities'],
        });
        resolve(res.data['user-activities']);
      })
      .catch((error) => {
        dispatch({
          type: Constants.REISSUE_EXPIRED_POINTS_FAILED,
          payload: error.data['user-activities'],
        });
        reject(error);
      });
  });

export const getClassifications = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_CLASSIFICATIONS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/activity-types/classifications/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_CLASSIFICATIONS_SUCCESS,
          payload: res.data.classifications,
        });
        resolve(res.data.classifications);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_CLASSIFICATIONS_FAILED, payload: error });
        reject(error);
      });
  });

export const getFrequencyPeriods = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_FREQUENCY_PERIODS_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/activity-types/frequency-periods/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_FREQUENCY_PERIODS_SUCCESS,
          payload: res.data['frequency-periods'],
        });
        resolve(res.data['frequency-periods']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_FREQUENCY_PERIODS_FAILED, payload: error });
        reject(error);
      });
  });

export const clearActivityType = () => (dispatch) =>
  dispatch({ type: Constants.CLEAR_USER_ACITIVITY_TYPE });
